module.exports = __webpack_public_path__ + "img/sttfbarbacena.2b2bbb51.png";